import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';

import { Summary } from './summary.component';
import {
  selectBookingTickets,
  selectDiscount,
  selectGroupPrice,
  selectIsGroupExperience,
} from '../../../../modules/booking';
import { selectCurrentExperienceDiscountPercent, selectExperienceTicketTypes } from '../../../../modules/experience';

const mapStateToProps = createStructuredSelector({
  ticketTypes: selectExperienceTicketTypes,
  selectedTickets: selectBookingTickets,
  discountValue: selectDiscount,
  discountPercent: selectCurrentExperienceDiscountPercent,
  isGroupExperience: selectIsGroupExperience,
  groupPrice: selectGroupPrice,
});

export const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(Summary);
